<template>
<transition name="slide-fade">
    <div class="dialog-view" v-show="visible" @click="destroyElement">        
        <div class="tips-modal u-window">           
            <div class="tips-content">
                <div class="content" v-html="tips_contxt"></div>
            </div>
        </div> 
        <div class="u-mask"></div>
    </div>
</transition>    
</template>

<script>
export default {
    name : 'tips-app',
    data : function () {
        return {
            visible : false,
            item_id : '',
            data : () => {},
            tips_contxt : '',
            text : '',
            type : 'text',
            src : 'https://web-resource.17m3.com/m3guo/202109/adshop/images/tips/',            
        }
    },
    created (){
        this.data = this.$tips_data
        //this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.data[this.item_id]) : '<div class="img"><img src="'+ this.src + this.item_id +'" style="width:100%"></div>';
        this.getContext (this.item_id);
    },
    watch: {
        closed (newVal) {
            if (newVal) {
                this.visible = false
                this.destroyElement()
            }
        }
    },
    methods: {
        destroyElement () {
            this.$destroy()
            this.$el.parentNode.removeChild(this.$el)
        },
        fuckTipsTxtFormat(item){

            //if(!text)return '详细内容见游戏';

            return item.replace(/\|r\|n\|cff99d3ff\s\|r\|pUI.*?\|e\|(\w{9})/gi, "|r|n|$1")
            .replace(/\|r\|n\|cFFFF0000已激活/g, "")
            .replace(/\|r\|pUI(.*?)\|e\|\S*/g, "").replace(/\|n/g, "<br/>")
            .replace(/\|cff(\w{6})/gi, '<span style="color:#$1">')                       
            .replace(/\|r/g, "</span>");      
        },
        getContext (id){
            let vm = this;
            if(!tips_data[vm.item_id] && vm.type != 'img'){
                vm.tips_contxt = '';
                vm.$axios({
                    method: 'get',
                    url: vm.$ajax_url_map.tips,
                    params:{
                        id : vm.item_id,
                        '_': +new Date(),
                    },
                    withCredentials: true,
                    responseType: 'json',
                    headers: {},
                })
                .then(res => {
                        //this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.data[this.item_id]) : '<div class="img"><img src="'+ this.src + this.item_id +'" style="width:100%"></div>';
                    },rej => {
                        //sick code
                        if(rej.code == 1){
                            //success
                            vm.data = rej.data[0];

                            tips_data[id] = rej.data[0];
                            vm.setHtml();
                        }
                    })
                .catch(err=>{
                    console.error(err);
                })          
            }
            else{
                vm.data = tips_data[vm.item_id];
                vm.setHtml();
            }            
        },
        setHtml (){
            var temp = this.data ? this.data.desc : '详细内容见游戏';
            this.text = this.type != 'img' ? temp : '';
            let file = (this.item_id == 'J237') ? 'gif' : 'png';
            this.item_id = (this.item_id == 'J237.png') ? this.item_id.replace('.png','.gif') : this.item_id;
            this.tips_contxt = this.type != 'img' ? this.fuckTipsTxtFormat(this.text) : ('<div class="img"><img src="'+ this.src + this.item_id + '"></div>');            
        },        
    }    
}
</script>

<style scoped>
    .tips-content{
        width: 750px;
        color: #fff;
    }

    .tips-content .content .img{
        width: 750px;
        text-align: center;
    }
    
    .tips-content .content{
        padding: 0 10px;
    }
</style>

<style>
    .tips-content .img{
        text-align: center;
    }
    
</style>


// WEBPACK FOOTER //
// src/components/ItemTips/itemTips.vue